import $ from 'jquery';
import gsap from 'gsap';

const onglet = {
	init() {
		// Vérifier et marquer les onglets
		$(".__onglet").each(function () {
			if (onglet.check($(this))) {
				$(this).addClass("__valid_onglet");
			} else {
				$(this).addClass("__no_more");
			}
		});

		// Toggle "show more" sur les onglets
		$(document).on("click", ".__onglet > ._show_more", function () {
			const $el = $(this).parent();
			$el.toggleClass("_open");
			$(this).attr('aria-expanded', String($el.hasClass('_open')));

			if ($el.hasClass("_open") && $el.hasClass("__others_intro")) {
				const $expandedContent = $el.find(".__others_intro_expanded");

				if ($expandedContent.length) {
					gsap.to("html,body", {
						scrollTo: $expandedContent.offset().top - 150,
						duration: 0.6
					});
				}
			} else if (!$el.hasClass("_open")) {
				const pos = $el.offset();
				gsap.to("html,body", {
					scrollTo: pos.top - 300,
					duration: 0.6
				});
			}
		});

		// Accordéon comportement
		$(document).on("click", "._accordion", function () {
			$("._accordion").not(this).removeClass("_open").find(".__answer").slideUp();
			$(this).toggleClass("_open").find(".__answer").slideToggle();
		});
	},

	check($el) {
		if ($el.is('[data-has-complement="true"]')) {
			return true;
		}

		const contentShort = $el.find(".__content._short").height() || 0;
		const contentLong = $el.find(".__content._long").height() || 0;
		return contentLong > contentShort;
	}
};

export default onglet;
